let tabs = document.querySelector('.tabs');
let tabButtons = document.querySelectorAll('.tab-link');
let tabPanels = Array.from(document.querySelectorAll('.tab-content'));

function showPanel(panel) {
  tabPanels.forEach((tabPanel) => {
    if (tabPanel.id === panel) {
      tabPanel.classList.add('is-active');
      tabPanel.classList.remove('is-hidden');
    } else {
      tabPanel.classList.add('is-hidden');
      tabPanel.classList.remove('is-active');
    }
  });

  const linkPanelId = panel + '-link';
  tabPanels.forEach((tabPanel) => {
    if (tabPanel.id === linkPanelId) {
      tabPanel.classList.add('is-active');
      tabPanel.classList.remove('is-hidden');
    } else if (tabPanel.id.endsWith('-link')) {
      tabPanel.classList.add('is-hidden');
      tabPanel.classList.remove('is-active');
    }
  });
}

function setActiveButton(targetId) {
  tabButtons.forEach((tabButton) => {
    if (tabButton.dataset.target === targetId) {
      tabButton.classList.add('is-active');
    } else {
      tabButton.classList.remove('is-active');
    }
  });
}

tabs.addEventListener('click', (event) => {
  if (event.target.classList.contains('tab-link')) {
    showPanel(event.target.dataset.target);
    setActiveButton(event.target.dataset.target);
  }
});

const defaultTabId = tabButtons[0].dataset.target;
showPanel(defaultTabId);
setActiveButton(defaultTabId);